/**
 * @generated SignedSource<<ac86a36f276ccac62f6cbc6c8bd41045>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AsanaWrapper_viewer$data = {
  readonly user: {
    readonly id: string;
    readonly orgs: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly asanaAccountErrorable: {
            readonly __typename: "AsanaAccount";
            readonly hasAsanaCredentials: boolean;
          } | {
            readonly __typename: "GraphEntityError";
            readonly message: string | null;
            readonly statusCode: number | null;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          };
          readonly primaryOrgCalendar: string;
          readonly flowStates: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly flowKey: string | null;
                readonly previousState: string | null;
                readonly current: {
                  readonly state: string | null;
                  readonly percentComplete: number | null;
                  readonly errorMessage: string | null;
                } | null;
                readonly pending: {
                  readonly state: string | null;
                  readonly percentComplete: number | null;
                  readonly errorMessage: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    };
    readonly flowStates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly flowKey: string | null;
          readonly previousState: string | null;
          readonly current: {
            readonly state: string | null;
            readonly percentComplete: number | null;
            readonly errorMessage: string | null;
          } | null;
          readonly pending: {
            readonly state: string | null;
            readonly percentComplete: number | null;
            readonly errorMessage: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "AsanaWrapper_viewer";
};
export type AsanaWrapper_viewer$key = {
  readonly " $data"?: AsanaWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AsanaWrapper_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "state",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentComplete",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorMessage",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": (v1/*: any*/),
  "concreteType": "FlowStateConnection",
  "kind": "LinkedField",
  "name": "flowStates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FlowStateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlowState",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flowKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousState",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FlowStatus",
              "kind": "LinkedField",
              "name": "current",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FlowStatus",
              "kind": "LinkedField",
              "name": "pending",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "flowStates(first:1000000)"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AsanaWrapper_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "OrgConnection",
          "kind": "LinkedField",
          "name": "orgs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Org",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "asanaAccountErrorable",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "hasAsanaCredentials",
                              "storageKey": null
                            }
                          ],
                          "type": "AsanaAccount",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "message",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "statusCode",
                              "storageKey": null
                            }
                          ],
                          "type": "GraphEntityError",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "primaryOrgCalendar",
                      "storageKey": null
                    },
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "orgs(first:1000000)"
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "0fd1055fcdbefae7ef4230bca4f38a2e";

export default node;
